import React from "react";
import { Link } from "react-router-dom";

const aboutExp = ({ aboutExp }) => {
  return (
    <>
      <div className="row">
        {aboutExp?.map((exp, index) => (
          <div key={index} className="col-lg-4 d-flex">
            <div className="exp-box">
              <p>{exp?.name}</p>
              <p>
                {exp?.yearFrom}-{exp?.yearTo}
              </p>
              <p className="whitespace-pre-wrap">{exp?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* <div className="row">
            <div className="col-lg-4 d-flex">
                <div className="exp-box">
                    <p>Mascola Group</p>
                    <p>2019-2020</p>
                    <p>I embraced the challenge of transforming the company’s brand identity. My role went beyond design, as I was heavily involved in developing and executing digital communication and marketing strategies that positioned the company for growth. From overseeing the visual identity to shaping the company's messaging across digital platforms, my work focused on creating a cohesive, compelling brand experience.</p>
                </div>
            </div>
            <div className="col-lg-4 d-flex">
                <div className="exp-box">
                    <p>Saudi Aramco</p>
                    <p>2020-2021</p>
                    <p>My time with Aramco’s Corporate Events Department honed my ability to enhance user experiences during VIP events. I led the design and production of awards and comprehensive event materials, ensuring every aspect—from concept to execution—reflected professionalism and excellence. I also worked closely on communication strategies for these events, ensuring that the visual and verbal messaging worked together seamlessly to deliver high-impact results.</p>
                </div>
            </div>
            <div className="col-lg-4 d-flex">
                <div className="exp-box">
                    <p>Imam Abdulaziz Royal Reserve Development Authority</p>
                    <p>2021-2024</p>
                    <p>Imam Abdulaziz Royal Reserve Development Authority: As one of the first employees at IARDA, I had the unique opportunity to shape the organization’s brand from the ground up. Working closely with leadership, I helped establish IARDA’s visual and communication identity, ensuring consistency across digital platforms, print materials, and public exhibitions. I played a key role in creating the organization's character and making sure its messaging resonated with diverse audiences.</p>
                </div>
            </div>
        </div> */}
    </>
  );
};

export default aboutExp;
